<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{
  changes: changes$ | async,
  editStatus: editStatus$ | async,
  successMessage: successMessage$ | async
}">

</ng-container>

<ng-template #template let-changes="changes" let-editStatus="editStatus" let-successMessage="successMessage">
  <div flex flexLayout="row" flexLayoutAlign="space-between center" class="action-row">
    @if (changes > 0 && editStatus === 'untouched') {
      <div flex flexLayout="row" flexLayoutAlign="start center">
        <span>{{changes}} pending {{changes > 1 ? "changes" : "change"}}</span>
        <mat-icon title="Preview Change Operations" (click)="showPreview()">help</mat-icon>
      </div>
    }
    @if (editStatus === 'saving') {
      <div flex flexLayout="row" flexLayoutAlign="start center">
        <mat-spinner diameter="16"></mat-spinner>
        <span>Saving your changes...</span>
      </div>
    }
    @if (editStatus === 'saved') {
      <div flex flexLayout="row" flexLayoutAlign="start center">
        <span class="success">Tag Saved Successfully</span>
      </div>
    }
    @if (editStatus === 'untouched') {
      <div flex="30" flexLayout="row" flexLayoutAlign="end center">
        <button mat-flat-button type="button" (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" type="button" (click)="save()">Save</button>
      </div>
    }
  </div>
</ng-template>
